angular.module('upsales.fileUploaderPatch', []).run([
	'FileUploader',
	function (FileUploader) {
		FileUploader.FileSelect.prototype.isEmptyAfterSelection = function () {
			return true;
		};
	}
]);
